import  Vue from  'vue';
Vue.mixin({
    methods: {
        capitalizeFirstLetter: str => str.charAt(0).toUpperCase() + str.slice(1),
        checkNull: function(value){
            return typeof value === 'undefined' || value === null;
        },
    }
})
/*
 *
 *   INSPINIA - Responsive Admin Theme
 *   version 2.7.1
 *
 */
// $(document).ready(function () {
//     // Add body-small class if window less than 768px
//     if ($(this).width() < 769) {
//         $('body').addClass('body-small')
//     } else {
//         $('body').removeClass('body-small')
//     }

//     // MetsiMenu
//     $('#side-menu').metisMenu();

//     // Collapse ibox function
//     $('.collapse-link').on('click', function () {
//         var ibox = $(this).closest('div.ibox');
//         var button = $(this).find('i');
//         var content = ibox.children('.ibox-content');
//         content.slideToggle(200);
//         button.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
//         ibox.toggleClass('').toggleClass('border-bottom');
//         setTimeout(function () {
//             ibox.resize();
//             ibox.find('[id^=map-]').resize();
//         }, 50);
//     });

//     // Close ibox function
//     $('.close-link').on('click', function () {
//         var content = $(this).closest('div.ibox');
//         content.remove();
//     });

//     // Fullscreen ibox function
//     $('.fullscreen-link').on('click', function () {
//         var ibox = $(this).closest('div.ibox');
//         var button = $(this).find('i');
//         $('body').toggleClass('fullscreen-ibox-mode');
//         button.toggleClass('fa-expand').toggleClass('fa-compress');
//         ibox.toggleClass('fullscreen');
//         setTimeout(function () {
//             $(window).trigger('resize');
//         }, 100);
//     });

//     // Minimalize menu
//     $('.navbar-minimalize').on('click', function (event) {
//         event.preventDefault();
//         $("body").toggleClass("mini-navbar");
//         SmoothlyMenu();

//     });

//     $('.input-group.date').datetimepicker();

//     var config = {
//                 '.chosen-select'           : {},
//                 '.chosen-select-deselect'  : {allow_single_deselect:true},
//                 '.chosen-select-no-single' : {disable_search_threshold:10},
//                 '.chosen-select-no-results': {no_results_text:'Oops, nothing found!'},
//                 '.chosen-select-width'     : {width:"95%"}
//             }
//             for (var selector in config) {
//                 $(selector).chosen(config[selector]);
//             }

//         toastr.options = {
//           "closeButton": true,
//           "debug": false,
//           "progressBar": true,
//           "preventDuplicates": false,
//           "positionClass": "toast-top-right",
//           "onclick": null,
//           "showDuration": "300",
//           "hideDuration": "1000",
//           "timeOut": "5000",
//           "extendedTimeOut": "500",
//           "showEasing": "swing",
//           "hideEasing": "linear",
//           "showMethod": "fadeIn",
//           "hideMethod": "fadeOut"
//         }

//         $('input[name="country"]').typeahead({
//             source: [
//                    "India",
//             ]
//         });

//         $('input[name="city"]').typeahead({
//             source: [
//                    "Mumbai",
//                    "Pune",
//                    "Thane",
//                    "Kalyan",
//                    "Bengaluru",
//                    "Kolkata",
//                    "Ahmedabad",
//                    "Surat",
//                    "Gurgaon",
//                    "Delhi",
//                    "Hyderabad",
//             ]
//         });

//         $(".txt-only-number").keydown(function (e) {
//             // Allow: backspace, delete, tab, escape, enter and .
//             if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
//                 // Allow: Ctrl+A, Command+A
//                 (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
//                 // Allow: home, end, left, right, down, up
//                 (e.keyCode >= 35 && e.keyCode <= 40)) {
//                 // let it happen, don't do anything
//                 return;
//             }
//             // Ensure that it is a number and stop the keypress
//             if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
//                 e.preventDefault();
//             }
//         });

//     // Full height of sidebar
//     function fix_height() {
//         var heightWithoutNavbar = $("body > #wrapper").height() - 61;
//         $(".sidebard-panel").css("min-height", heightWithoutNavbar + "px");

//         var navbarHeight = $('nav.navbar-default').height();
//         var wrapperHeight = $('#page-wrapper').height();

//         if (navbarHeight > wrapperHeight) {
//             $('#page-wrapper').css("min-height", navbarHeight + "px");
//         }

//         if (navbarHeight < wrapperHeight) {
//             $('#page-wrapper').css("min-height", $(window).height() + "px");
//         }

//         if ($('body').hasClass('fixed-nav')) {
//             if (navbarHeight > wrapperHeight) {
//                 $('#page-wrapper').css("min-height", navbarHeight + "px");
//             } else {
//                 $('#page-wrapper').css("min-height", $(window).height() - 60 + "px");
//             }
//         }

//     }

//     fix_height();

//     // Fixed Sidebar
//     $(window).bind("load", function () {
//         if ($("body").hasClass('fixed-sidebar')) {
//             $('.sidebar-collapse').slimScroll({
//                 height: '100%',
//                 railOpacity: 0.9
//             });
//         }
//     });

//     $(window).bind("load resize scroll", function () {
//         if (!$("body").hasClass('body-small')) {
//             fix_height();
//         }
//     });

//     // Add slimscroll to element
//     $('.full-height-scroll').slimscroll({
//         height: '100%'
//     })
// });


// // Minimalize menu when screen is less than 768px
// $(window).bind("resize", function () {
//     if ($(this).width() < 769) {
//         $('body').addClass('body-small')
//     } else {
//         $('body').removeClass('body-small')
//     }
// });

// function SmoothlyMenu() {
//     if (!$('body').hasClass('mini-navbar') || $('body').hasClass('body-small')) {
//         // Hide menu in order to smoothly turn on when maximize menu
//         $('#side-menu').hide();
//         // For smoothly turn on menu
//         setTimeout(
//             function () {
//                 $('#side-menu').fadeIn(400);
//             }, 200);
//     } else if ($('body').hasClass('fixed-sidebar')) {
//         $('#side-menu').hide();
//         setTimeout(
//             function () {
//                 $('#side-menu').fadeIn(400);
//             }, 100);
//     } else {
//         // Remove all inline style from jquery fadeIn function to reset menu state
//         $('#side-menu').removeAttr('style');
//     }
// }

// $('#app_msg').modal('show');

// setTimeout(function() {
//     $('#app_msg').modal('hide');
// }, 1500);
